// frontend/src/utils/ImageUtil.js

/**
 * Helper function to handle different image URL formats and ensure correct display
 * @param {string} imageUrl - The image URL to process
 * @returns {string} - Properly formatted image URL
 */
export const getFormattedImageUrl = (imageUrl) => {
    if (!imageUrl) return 'https://via.placeholder.com/400x300?text=Image+Not+Available';
    
    // If it's already a complete URL, return it as is
    if (imageUrl.startsWith('http')) {
      return imageUrl;
    }
    
    // If it's a relative path, append the S3 bucket URL
    const s3BucketUrl = process.env.REACT_APP_S3_BUCKET_URL || 'https://meatbuddy-assets.s3.eu-north-1.amazonaws.com';
    
    // If it already has the path structure that matches S3 path pattern, return the full URL
    if (imageUrl.includes('product-images/') || imageUrl.includes('user-avatars/')) {
      return `${s3BucketUrl}/${imageUrl}`;
    }
    
    // For local server images (should be migrated, but just in case)
    if (imageUrl.startsWith('/uploads/')) {
      return `${process.env.REACT_APP_API_URL || 'http://localhost:8000'}${imageUrl}`;
    }
    
    // Default case - assume it's a relative path to an S3 object
    return `${s3BucketUrl}/${imageUrl}`;
  };